module.exports = __webpack_public_path__ + "files/5ad152a6d5e225a4cd3b76f43aefaf7c.png";